/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ConfigActionIds {
    FilterToolbarSiteSearch = 'FilterToolbar.SiteSearch',
    FilterToolbarCompanySearch = 'FilterToolbar.CompanySearch',
}
